import React from "react";
import { Popover } from "antd";
import { weekOptions } from "../../helpers/GlobalOptions";
import { AiOutlineCalendar } from "react-icons/ai";

function SelectWeekDays({ value = [], onChange, error }) {
  return (
    <Popover
      placement="bottomLeft"
      title={"Select week days"}
      content={
        <div className="w-100">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 12,
            }}
          >
            {weekOptions.map((option) => {
              const active = value && value.includes(option.value);
              return (
                <div
                  key={option.value}
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    backgroundColor: active ? "#E6F7FF" : "transparent",
                    borderRadius: 3,
                    padding: "4px, 1px, 4px, 1px",
                  }}
                  onClick={() => {
                    if (active) {
                      return onChange({
                        target: {
                          name: "schedule_days",
                          value: value.filter((val) => val !== option.value),
                        },
                      });
                    }
                    return onChange({
                      target: {
                        name: "schedule_days",
                        value: value
                          ? [option.value, ...value]
                          : [option.value],
                      },
                    });
                  }}
                >
                  {option.label}
                </div>
              );
            })}
          </div>
        </div>
      }
      trigger="click"
    >
      <div
        className={`ant-input w-100 position-relative ${
          error ? "error_border" : ""
        }`}
      >
        {value && Array.isArray(value) && value.length > 0 ? (
          <span>{value.join(";")}</span>
        ) : (
          <span style={{ color: "#BFBFBF" }}>Select week days</span>
        )}
        <div
          className="position-absolute"
          style={{
            top: 4,
            right: 11,
          }}
        >
          <AiOutlineCalendar color="#BFBFBF" />
        </div>
      </div>
    </Popover>
  );
}

export default SelectWeekDays;
